module.exports = __webpack_public_path__ + "36f53e13a3002cb1d38dee051a2600ae.svg";